/* eslint-disable no-unused-vars */
import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import auth from "src/auth/authService";
import Vue from "vue";
import store from "src/store/store";
import router from "./router";
import { translate_error, translate_error_title } from "./utils/error-helper";
import { revokeToken } from "src/api-services/account";
// import {
//   data
// } from "jquery";
window.revoking = false;
const hostname = window.location.hostname;
const httpClient = axios.create({
  baseUrl: process.env.VUE_APP_BASE_API,
  headers: {
    "Content-Type": "application/json",
    BaseUrlWebSite: hostname,
    // anything you want to add to the headers
  },
  withCredentials: true,
});
if (auth.isAuthenticated()) {
  const authInterceptor = (config) => {
    // const authToken = localStorage.getItem("authToken");
    const authToken = store.getters.authToken;
    config.headers["Authorization"] = authToken;
    axios.defaults.headers.common["Authorization"] = authToken;
    return config;
  };
  httpClient.interceptors.request.use(authInterceptor);
}

// interceptor to catch errors
const errorInterceptor = async (error) => {
  const vm = new Vue();
  const originalRequest = error.config;
  // const authToken = localStorage.getItem("authToken");
  const authToken = store.getters.authToken;
  const errorData =
    error.response && error.response.data ? error.response.data.errors : null;
  let errorText = "";
  if (errorData && errorData[0]) {
    // Handle both lowercase and uppercase property names
    const errorTitle = errorData[0].title || errorData[0].Title;
    const errorDescription =
      errorData[0].description || errorData[0].Description;

    if (errorTitle === "RayanException") {
      errorText = errorDescription;
    } else {
      // Check if the title is in English (needs translation) or Persian (direct display)
      const isEnglishTitle = /^[a-zA-Z]/.test(errorTitle);

      if (isEnglishTitle) {
        // For English titles, use translation
        errorText = translate_error(errorTitle);
      } else {
        // For Persian titles, show directly
        errorText = errorTitle;
        if (errorDescription) {
          errorText += `: ${errorDescription}`;
        }
      }
    }
  }

  if (error.response.status === 500) {
    const errorDescription =
      error.response.data.errors[0].description ||
      error.response.data.errors[0].Description;
    const errorId = errorDescription.split("ErrorId: ")[1];
    return vm.$vs.notify({
      time: 20000,
      title: "خطا در سرور پیش آمده!",
      text: `
      <div class="flex justify-between items-center text-gray-g2 text-base">
            <input id='copyInput' style='position: absolute; left: -1000px; top: -1000px' value='${errorId}' /><br />
            <span id onclick="document.getElementById('copyInput').select(); document.execCommand('copy');" class="cursor-pointer">${errorId}</span>
            <a href="mailto:it@kourosh-am.com?subject=finowall server error&body=${errorId}" class="font-bold ml-8 cursor-pointer text-black">ارسال خطا</a>
      </div>`,
      color: "error",
    });
  }
  if (error.response.status === 429) {
    return vm.$vs.notify({
      time: 20000,
      title: "تعداد درخواست بیش از حد مجاز",
      color: "error",
    });
  }
  if (
    error.response.status === 400 &&
    error.response.data.errors[0].title === "InvalidGiftCode"
  ) {
    return vm.$vs.notify({
      time: 20000,
      title: "کد هدیه نامعتبر است",
      color: "error",
    });
  }
  if (
    error.response.status === 400 &&
    error.response.data.errors[0].title === "GiftCodeConsumed"
  ) {
    return vm.$vs.notify({
      time: 20000,
      title: "کد هدیه قبلا استفاده شده است",
      color: "error",
    });
  }
  if (error.response.status === 422) {
    if (error.response.data.errors[0].title === "InvalidDocumentType") {
      return vm.$vs.notify({
        time: 20000,
        title: "فرمت فایل معتبر نیست",
        color: "error",
      });
    } else {
      return vm.$vs.notify({
        time: 20000,
        title: errorText,
        color: "error",
      });
    }
  }

  return Promise.reject(error);
};

// Interceptor for responses
const responseInterceptor = (response) => {
  if (response.data && response.data.errors) {
    const vm = new Vue();
    vm.$vs.notify({
      time: 8000,
      title: "خطا",
      text: translate_error(response.data.errors[0].title),
      color: "danger",
    });
    return Promise.reject(response.data.error.title);
  }

  return response;
};

const refreshAuthLogic = (failedRequest) =>
  store.getters.authToken
    ? revokeToken({
        userId: store.getters.userId,
        scope: "user",
        refreshToken: store.getters.refreshToken,
      })
        .then((revokeResult) => {
          store.commit("SET_ACCESS_TOKEN", revokeResult.data.result.authToken);
          store.commit(
            "SET_REFRESH_TOKEN",
            revokeResult.data.result.refreshToken,
          );
          failedRequest.response.config.headers["Authorization"] =
            "Bearer " + revokeResult.data.result.authToken;
          return Promise.resolve();
        })
        .catch((err) => {
          store.commit("SET_TOKEN_EXPIRED", true);
          store.commit("SET_USER_STEP", null);
          store.commit("SET_ACCESS_TOKEN", null);
          store.commit("SET_REFRESH_TOKEN", null);
          store.commit("SET_USER_ID", null);
          store.commit("SET_USER_INFO", null);
          store.commit("SET_ACCOUNT_INFO", null);
          router.push("/login").catch(() => {});
          // Vue.prototype.interVals.forEach(element => {
          //   clearInterval(element)
          // });
        })
    : Promise.reject();

createAuthRefreshInterceptor(httpClient, refreshAuthLogic);

httpClient.interceptors.response.use(responseInterceptor, errorInterceptor);

export default httpClient;
